import { createAction, props } from '@ngrx/store';
import { Contenido } from 'src/common/contenido';

// Detalle actions
export const detalleRequested = createAction( '[Detalle Resolver] Detalle Requested', props<{ contenidoRid: string }>()  );
export const detalleLoaded = createAction( '[Contenido API] Detalle Loaded', props<{ detalle: Contenido }>() );
export const detalleCancelled = createAction( '[Contenido API] Detalle Cancelled' );
export const detalleCleared = createAction( '[Detalle Component] Detalle Cleared' );
// Reporte actions
export const detalleEmergenciaRequested = createAction( '[Emergencia Component] Emergencia Requested' );